import { render, staticRenderFns } from "./ThanksEvaluation.vue?vue&type=template&id=54fd2794"
import script from "./ThanksEvaluation.vue?vue&type=script&lang=js"
export * from "./ThanksEvaluation.vue?vue&type=script&lang=js"
import style0 from "./ThanksEvaluation.vue?vue&type=style&index=0&id=54fd2794&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports